<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    custom-class="dialog-long-form"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose">
    <div v-loading="isLoading">
      <form-editor
        :data="data"
        :model="formModel"
        @updateModelItem="handlerUpdateModelItem"
        @change="handleFormData"
        ref="Form"/>
      <form-controls
        class="form-footer"
        isCancel
        isSave
        isDelete
        @command="setCommand"/>
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'

export default {
  name: 'ModalNewLabel',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'form-editor': () => import(/* webpackChunkName: 'QuickRFQ2' */ './../FormRFQ2'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object },
    formModel: { type: Function, required: true },
    isHighPermission: { type: Boolean, required: true }
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'RFQ2s/Patch/${data.id}'
    }
  },
  computed: {
    formTitle () {
      return this.formData.rfqid || this.checkEs6AndRun(this.title)
    },
    currentUser () {
      return this.$store.getters.get('currentUser')
    }
  },
  methods: {
    handleDialogClose () {
      let command = this.isAvailableToSave ? 'back' : 'cancel'
      this.setCommand(command)
    },
    // MIXINS
    handleChangeMode () {
      if (this.state === 'new') {
        this.setQuery()
      }
    },
    handleCameData (data) {
      let canEdit = true

      if (!this.isHighPermission) {
        canEdit = this.currentUser.employeeID === data.employeeID
      }

      if (!canEdit) {
        this.setQuery()
        this.$notify.warning(this.L10n('low-role-to-edit'))
      }
    }
  }
}
</script>
